import React, { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import {
	LoggerProvider,
	PreviewProvider,
	ScriptTagProvider,
	StorageProvider,
	SessionWrapper,
	getCurrentScript,
} from '@rmc/webcx-web-libs';
import { MainApp } from './components';
import { Logger } from './components/Logger';
import { queryClient } from './api/queryClient';
import {
	LOGGER_KEY,
	SCRIPT_ID,
	LOCAL_STORAGE_KEY,
	LEGACY_LOCAL_STORAGE_KEY,
} from './config';
import { CampaignsProvider } from './context/CampaignsContext';

function App({
	currentScript,
}: {
	currentScript?: HTMLElement | null | SVGScriptElement;
}) {
	const [currentScriptNode, setCurrentScriptNode] = useState<
		HTMLElement | null | SVGScriptElement
	>(null);

	useEffect(() => {
		const script =
			currentScript || getCurrentScript(process.env.REACT_APP_SCRIPT_ID || '');
		setCurrentScriptNode(script);
	}, [currentScript]);

	if (!currentScriptNode) {
		return null;
	}

	return (
		<ScriptTagProvider currentScript={currentScript} scriptId={SCRIPT_ID}>
			<StorageProvider
				localStorageKey={LOCAL_STORAGE_KEY}
				legacyLocalStorageKey={LEGACY_LOCAL_STORAGE_KEY}
			>
				<QueryClientProvider client={queryClient}>
					<PreviewProvider>
						<LoggerProvider logKey={LOGGER_KEY}>
							<>
								<Logger domNode={currentScriptNode} />
								<CampaignsProvider>
									<SessionWrapper>
										<MainApp />
									</SessionWrapper>
								</CampaignsProvider>
							</>
						</LoggerProvider>
					</PreviewProvider>
				</QueryClientProvider>
			</StorageProvider>
		</ScriptTagProvider>
	);
}

export default App;
